import { authFetch } from "./base";
export const fetchServerStats = async () => {
    const response = await authFetch('api/admin/stats');
    if (!response.ok) {
        let detail = response.statusText;
        try {
            const json = (await response.json());
            if (json.message) {
                detail = json.message;
            }
        }
        catch {
            /* ignore */
        }
        throw new Error(`Failed to fetch server stats: ${detail}`);
    }
    const payload = await response.json();
    return payload.data;
};
